<template>

    <m-edit1/>

    <m-pages-1 v-bind='{...{},...{}}' :style='""' class="container my-5" ></m-pages-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mPages1 from '@moeinmdn/miw-alpha-components/src/package/Page/Pages/Pages1';

export default {
    name: 'HomeView',
    components: {mEdit1, mPages1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
